<ion-header class="ion-no-border premium-header">
  <div class="header-curve"></div>
  <div class="custom-toolbar">
    <div class="toolbar-content">
      <ion-buttons slot="start">
        <ion-menu-button *ngIf="!selectionMode" class="icon-btn"></ion-menu-button>
        <ion-button (click)="close()" *ngIf="selectionMode" class="icon-btn">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>

      <div class="title-group" (click)="loadTrabajos()">
        <div class="title-main">{{ selectionMode ? 'Vincular Trabajo' : 'Trabajos' }}</div>
        <div class="title-sub">Gestión de órdenes de trabajo</div>
      </div>

      <ion-buttons slot="end" *ngIf="!selectionMode">
        <ion-button (click)="toggleSearch()" class="icon-btn">
          <ion-icon name="search-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="loadTrabajos()" class="icon-btn">
          <ion-icon name="refresh-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
  <ion-searchbar *ngIf="showSearch" placeholder="Buscar..." (ionInput)="search($event)" mode="ios" [debounce]="250" class="premium-searchbar" style="margin: 0 16px 10px;"></ion-searchbar>
</ion-header>

<ion-content class="premium-content-bg" [fullscreen]="true">

  <div class="list-container">
    
    <!-- Loading state -->
    <div *ngIf="isLoading" class="loading-state">
      <ion-spinner name="bubbles"></ion-spinner>
      <p>Cargando trabajos...</p>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && displayedTrabajos.length === 0" class="empty-state">
      <ion-icon name="briefcase-outline"></ion-icon>
      <p>{{ selectionMode ? 'No hay trabajos sin cotización' : 'No hay trabajos' }}</p>
    </div>

    <!-- Cards -->
    <div class="premium-card trabajo-card" *ngFor="let t of displayedTrabajos" (click)="openMenu(t)">
      <div class="card-indicator"></div>

      <div class="card-main-col">
        <div class="card-content-upper">
          <div class="card-body">
            <div class="card-header-row">
              <span class="card-id">#{{ t.id }}</span>
              <div class="estado-badge" [ngStyle]="getEstadoColor(t.estado)">
                {{ t.estado }}
              </div>
            </div>

            <div class="card-main-info">
              <div class="titulo">{{ t.cliente }}</div>
              <div class="sub-titulo" *ngIf="t.lugar">
                <ion-icon name="location-outline"></ion-icon>
                <span>{{ t.lugar }}</span>
              </div>
              <div class="descripcion" *ngIf="t.descripcion">{{ t.descripcion }}</div>
            </div>

            <div class="card-meta-row">
              <div class="meta-item" *ngIf="t.solicitante">
                <ion-icon name="person-outline"></ion-icon>
                <span>{{ t.solicitante }}</span>
              </div>
              <div class="meta-item date">
                <ion-icon name="calendar-outline"></ion-icon>
                <span>{{ t.fecha_creacion | date:'dd/MM/yy' }}</span>
              </div>
            </div>
          </div>

          <div class="card-arrow" *ngIf="!selectionMode">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </div>
        </div>

        <!-- ARS badges -->
        <div class="ars-footer-row" *ngIf="t.isArsSigned || t.hasArsAttachment">
          <div class="ars-badge ars-signed" *ngIf="t.isArsSigned">
            <ion-icon name="checkmark-circle"></ion-icon>
            <span>Firmado</span>
          </div>
          <div class="ars-badge ars-pdf" *ngIf="t.hasArsAttachment">
            <ion-icon name="document-attach"></ion-icon>
            <span>PDF</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</ion-content>
